import { HelmetProvider } from "react-helmet-async";
import { LayoutProvider } from "../../../context/useLayoutContext";
import PageMetaData from "../../../components/PageMetaData";
import TopNavBar from "../../../components/TopNavBar";
import News from "../components/News";
import Footer from "../components/Footer";
import { useState } from "react";
import Calculator from "../components/Calculator";

const NewsPage = () => {
  const [showCalculator, setShowCalculator] = useState(false);

  const handleShowCalculator = () => {
    setShowCalculator(!showCalculator);
  };

  return (
    <HelmetProvider>
      <LayoutProvider>
        <PageMetaData title="Geo Express | News" />
        <TopNavBar
          position="fixed"
          menuItems={[
            ["მთავარი", "home", "/"],
            ["სერვისები", "services", "/services"],
            ["სიახლეები", "news", "/news", true],
            ["კონტაქტი", "contact", "/contact"],
            ["ხშირად დასმული კითხვები", "faqs", "/faq"],
            ["განსაბაჟებელი გზავნილები", "shipment", "/shipment"],
          ]}
          onCalculatorClick={handleShowCalculator}
        />
        <Calculator
          show={showCalculator}
          onClose={() => setShowCalculator(false)}
        />
        <News />
        <Footer />
      </LayoutProvider>
    </HelmetProvider>
  );
};

export default NewsPage;
